import NavBar from "../components/NavBar/NavBar";
import CoachChatbot from "../components/CoachChatbot/CoachChatbot";

export default function ChatPage() {
  return (
    <>
      <NavBar />
      <main className="web-view">
        <div className="container">
          <CoachChatbot />
        </div>
      </main>
    </>
  );
}
